import { Anchor, Box, Center, Text, useMantineTheme } from '@mantine/core'
import type { CSSProperties } from 'react'
import classes from './SidebarFooter.module.css'

export const SidebarFooter = () => {
  const theme = useMantineTheme()
  const isDark = theme.colorScheme === 'dark'

  const footerStyle = {
    '--sidebar-footer-background': isDark
      ? '#0d0e10'
      : 'rgba(43, 49, 70, 0.22)',
    '--sidebar-footer-border-color': isDark
      ? 'rgba(255, 255, 255, 0.08)'
      : 'rgba(255, 255, 255, 0.14)',
  } as CSSProperties

  return (
    <Center pt="xl" className={classes.footer} style={footerStyle}>
      <Box>
        <Text size="sm" c="dimmed">
          ConnectedLife &copy; {new Date().getFullYear()}
        </Text>
        <Anchor
          color={'dimmed'}
          href="https://connectedlife.pl/contact"
          target={'_blank'}
          className={classes.supportLink}
          ta="center"
          size="xs"
        >
          Contact support
        </Anchor>
      </Box>
    </Center>
  )
}
